import * as React from 'react';
import moment from 'moment';
import propz from 'propz';
import BPromise from 'bluebird';
import { parse } from 'query-string';
import { History, Location } from 'history';
import { Component } from 'react';
import { AppUser } from 'Src/views/App/App';
import {
  getParentArchiveMessages,
  getParentArchiveMessagesCount,
  cancelRejectionOfParentConsentRequest
} from 'Src/helpers/service/parent/messagesTable';
import { Loader } from 'Src/components/Loader/Loader';
import { ConsentRequestCard } from 'Src/components/ConsentRequestCard/ConsentRequestCard';
import { DATE_INTERVAL, FILTER_TYPE, FIRST_PAGE, CARD_LIMIT } from 'Src/consts/table';
import {
  ColumnDefinition,
  getFilters2,
  getServerQueryFilter2,
  isFilterExist2,
  isSortExist,
  TABLE_SORT_DIRECTION,
  getSearchFilter,
  getSearchOrder,
  getOrder,
  getServerFieldSectionWhere
} from 'Src/helpers/table/table';
import { Pagination2 } from 'Src/components/Pagination/Pagination2';
import { getChildren } from 'Src/helpers/service/parent/children';
import { EventInvitationMessage } from 'Src/models/message';
import { SchoolEvent } from 'Src/models/event';
import { Child } from 'Src/models/child';
import { INVITE_TYPE } from 'Src/consts/invite';
import { SimpleModal } from 'Src/components/SimpleModal/SimpleModal';
import { Map } from 'Src/components/Map/Map';
import { ConsentRequestDetails } from '../ConsentRequestDetails/ConsentRequestDetails';
import { ParentConsentEventList } from '../ParentConsentEventList';
import { hydrateParentConsentEvents } from '../getParentConsentEventName';
import '../ConsentRequestsInbox/ConsentRequestsInbox.scss';
import { ItemsBar } from 'Src/views/GenericView/ParentView/Calendar/ItemsBar';
import { ParentFilterBar } from 'Src/components/ParentFilterBar/ParentFilterBar';
import { AppliedTextFilterChip } from 'Src/components/AppliedTextFilterChip/AppliedTextFilterChip';
import { MessageField } from 'Src/models/message';
import { FormSubmission } from 'Src/types/formSchema';
import { updateParentConsentRequest } from 'Src/helpers/service/parent/messagesTable';
import { ParentalConsentRequestForm } from '../ConsentRequestsInbox/ParentalConsentRequestForm/ParentalConsentRequestForm';
import { acceptParentConsentRequest, rejectParentConsentRequest } from 'Src/helpers/service/parent/messagesTable';
import './ConsentRequestsArchive.scss';
import { ParentPageHeader } from '../../components/ParentPageHeader';
import '../../components/ParentLists.scss';

const FILTER_FIELDS_ALL: ColumnDefinition[] = [
  { text: 'Children', field: 'childIdList', type: FILTER_TYPE.MULTISELECT, accessor: [''], isSort: false },
  { text: 'Sport', field: 'sport', type: FILTER_TYPE.TEXT, accessor: [''], isSort: false },
  { text: 'Event date', field: 'startTime', type: FILTER_TYPE.DATE_INTERVAL, accessor: [''], isSort: true },
  { text: 'Status', field: 'invitationStatus', type: FILTER_TYPE.TEXT, accessor: [''], isSort: true }
];

interface Props {
  user: AppUser;
  history: History;
  location: Location;
  mode?: 'current' | 'archive';
  setNeedUpdate?: () => void;
}

const academicYearRange = () => {
  const now = moment();
  const startYear = now.month() >= 8 ? now.year() : now.year() - 1;
  return {
    from: moment([startYear, 8, 1]).format('YYYY-MM-DD'),
    to: moment([startYear + 1, 8, 1])
      .subtract(1, 'day')
      .format('YYYY-MM-DD')
  };
};

interface State {
  items: { consentRequest: EventInvitationMessage; childEvent: SchoolEvent }[];
  selectedItem: { consentRequest: EventInvitationMessage; childEvent: SchoolEvent } | undefined;
  total: number;
  currentPage: number;
  filters: any;
  sortFieldName: string;
  sortDirection: string;
  isFiltersOpen: boolean;
  isLoading: boolean;
  children: Child[];
  basePath: string;
  isMapModalOpen: boolean;
  isDetailsModalOpen: boolean;
  isEditModalOpen: boolean;
  modalMode?: 'edit' | 'accept';
}

export class ConsentRequestsArchive extends Component<Props, State> {
  private loadRequestId = 0;

  constructor(props) {
    super(props);
    this.state = {
      items: [],
      selectedItem: undefined,
      total: 0,
      currentPage: FIRST_PAGE,
      filters: {},
      sortFieldName: '',
      sortDirection: '',
      isFiltersOpen: false,
      isLoading: false,
      basePath: '',
      children: [],
      isMapModalOpen: false,
      isDetailsModalOpen: false,
      isEditModalOpen: false,
      modalMode: undefined
    };
  }

  componentDidMount() {
    this.setState({ isLoading: true });
    this.setItems();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.location.search !== this.props.location.search || nextProps.mode !== this.props.mode) {
      this.setState({ isLoading: true });
      this.setItems(nextProps);
    }
  }

  private normalizeFiltersForQuery = (f: any) => {
    const out = { ...(f || {}) };

    const sportIdIn = propz.get(out, ['sportId', '$in']);
    if (typeof sportIdIn === 'string') out.sport = sportIdIn;
    else if (Array.isArray(sportIdIn) && sportIdIn.length) out.sport = sportIdIn[0];
    else if (typeof out.sportId === 'string') out.sport = out.sportId;
    delete out.sportId;

    const toIso = (s?: string) => {
      if (!s) return s;
      const m = s.match(/^(\d{2})[\/-](\d{2})[\/-](\d{4})$/);
      return m ? `${m[3]}-${m[2]}-${m[1]}` : s;
    };

    if (typeof out.startTime === 'string' || typeof out.finishTime === 'string') {
      out.startTime = { from: toIso(out.startTime), to: toIso(out.finishTime) };
      delete out.finishTime;
    } else if (out.startTime && (out.startTime.from || out.startTime.to)) {
      out.startTime = { from: toIso(out.startTime.from), to: toIso(out.startTime.to) };
    }

    if (typeof out.invitationStatus === 'string' && !out.invitationStatus.trim()) {
      delete out.invitationStatus;
    }

    return out;
  };

  private setItems(props: Props = this.props) {
    const requestId = ++this.loadRequestId;
    const { user, location } = props;
    const search = parse(location.search);

    const page = typeof search.page !== 'undefined' ? Number(search.page) : FIRST_PAGE;

    let sortDirection: TABLE_SORT_DIRECTION = '';
    let sortFieldName = '';
    if (typeof search.order === 'string') {
      [sortFieldName, sortDirection] = search.order.split(':');
    }

    const rawFilters = getFilters2(FILTER_FIELDS_ALL, search);
    const filtersForQuery = this.normalizeFiltersForQuery(rawFilters);
    const selectedYear = typeof search.year === 'string' ? Number(search.year) : undefined;
    const hasAppliedArchiveFilters = props.mode === 'archive' ? Number.isFinite(selectedYear) : true;

    if (props.mode === 'archive' && !hasAppliedArchiveFilters) {
      return getChildren(user)
        .then(children => {
          if (requestId !== this.loadRequestId) return;
          this.setState({
            items: [],
            currentPage: FIRST_PAGE,
            children,
            filters: filtersForQuery,
            sortDirection,
            sortFieldName,
            total: 0,
            basePath: location.pathname,
            isLoading: false
          });
        })
        .catch(() => {
          if (requestId === this.loadRequestId) this.setState({ isLoading: false });
        });
    }

    const { sport, startTime, invitationStatus, ...rest } = filtersForQuery;

    const academic = academicYearRange();
    const period =
      props.mode === 'archive'
        ? {
            from: moment([selectedYear, 8, 1]).format('YYYY-MM-DD'),
            to: moment([Number(selectedYear) + 1, 8, 1]).subtract(1, 'day').format('YYYY-MM-DD')
          }
        : { from: academic.from, to: moment().format('YYYY-MM-DD') };
    const where = {
      kind: 'EventInvitationMessage',
      ...getServerFieldSectionWhere(rest),
      ...(invitationStatus ? { invitationStatus } : {}),
      ...(sport ? { sport } : {}),
      ...{ startTime: startTime && (startTime.from || startTime.to) ? startTime : period }
    };

    const order = isSortExist(sortDirection, sortFieldName) ? `${sortFieldName} ${sortDirection}` : undefined;

    const serverQueryFilter = getServerQueryFilter2(page, where, order, CARD_LIMIT);

    const countWhere = { ...where };
    delete countWhere.childIdList;

    const getItemsPromise = getParentArchiveMessages(user, serverQueryFilter);
    const getItemsCountPromise = getParentArchiveMessagesCount(user, countWhere, true);
    const getChildrenPromise = getChildren(user);

    return BPromise.all([getItemsPromise, getItemsCountPromise, getChildrenPromise])
      .then(([consentRequests, consentRequestsCount, children]) => {
        if (requestId !== this.loadRequestId) return;
        const updatedItems = consentRequests.map((consentRequest: EventInvitationMessage) => ({
          consentRequest,
          childEvent: propz.get(consentRequest, ['eventData'], {}) as SchoolEvent
        }));

        const hasChildSelection = Array.isArray(filtersForQuery.childIdList) && filtersForQuery.childIdList.length > 0;
        const itemCounts = consentRequestsCount.itemCounts || {};
        const matchingTotal =
          hasChildSelection && consentRequestsCount.itemCounts
            ? filtersForQuery.childIdList.reduce((sum, childId) => sum + (itemCounts[String(childId)] || 0), 0)
            : Number(consentRequestsCount.count);
        const lastPage = Math.max(FIRST_PAGE, Math.ceil(matchingTotal / CARD_LIMIT));
        if (page > lastPage) {
          const parts: string[] = [];
          if (lastPage !== FIRST_PAGE) parts.push(`page=${lastPage}`);
          if (isSortExist(sortDirection, sortFieldName)) {
            parts.push(getSearchOrder(sortDirection, sortFieldName));
          }
          if (isFilterExist2(filtersForQuery)) parts.push(getSearchFilter(filtersForQuery));
          props.history.replace({ pathname: location.pathname, search: parts.join('&') });
          return;
        }
        const childrenWithCounts = (children || []).map(child => ({
          ...child,
          itemCount: itemCounts[String(child.id)] || 0
        }));

        const filtersWithChild = hasChildSelection
          ? filtersForQuery
          : { ...filtersForQuery, childIdList: children.map(c => c.id) };

        this.setState({
          items: updatedItems,
          currentPage: page,
          children: childrenWithCounts,
          filters: filtersWithChild,
          sortDirection,
          sortFieldName,
          total: matchingTotal,
          basePath: location.pathname,
          isLoading: false
        });
        hydrateParentConsentEvents(user, updatedItems).then(items => {
          if (requestId === this.loadRequestId) this.setState({ items });
        });
      })
      .catch(() => {
        if (requestId === this.loadRequestId) this.setState({ isLoading: false });
      });
  }

  private setCurrentPageParams = (currentPage: number): void => {
    const { filters, sortFieldName, sortDirection } = this.state;
    const parts: string[] = [];
    const year = parse(this.props.location.search).year;
    if (this.props.mode === 'archive' && typeof year === 'string') parts.push(`year=${year}`);

    if (currentPage !== 1) parts.push(`page=${currentPage}`);
    if (isSortExist(sortDirection, sortFieldName)) parts.push(getSearchOrder(sortDirection, sortFieldName));

    const filtersForUrl = this.normalizeFiltersForQuery(filters);
    if (isFilterExist2(filtersForUrl)) parts.push(getSearchFilter(filtersForUrl));

    this.props.history.push({ pathname: this.state.basePath, search: parts.join('&') });
  };

  private onTableFilterChange = (event, filterField: string, options?): void => {
    const filterValue = propz.get(event, ['target', 'value'], '');
    const { filters } = this.state;
    const currentFilterField = filters[filterField];

    let nextFilters = { ...filters };

    if (typeof options !== 'undefined') {
      switch (options) {
        case DATE_INTERVAL.FROM:
          nextFilters = { ...nextFilters, [filterField]: { ...currentFilterField, from: filterValue } };
          break;
        case DATE_INTERVAL.TO:
          nextFilters = { ...nextFilters, [filterField]: { ...currentFilterField, to: filterValue } };
          break;
      }
    } else if (filterField === 'invitationStatus') {
      if (filterValue) nextFilters = { ...nextFilters, invitationStatus: filterValue };
      else {
        nextFilters = { ...nextFilters };
        delete nextFilters.invitationStatus;
      }
    } else {
      const filter = FILTER_FIELDS_ALL.find(col => col.field === filterField);
      const filterType = filter?.type;

      if (filterType === FILTER_TYPE.MULTISELECT) {
        const optionsEl = event.target.options;
        const value: string[] = [];
        for (let i = 0; i < optionsEl.length; i++) {
          if (optionsEl[i].selected) value.push(optionsEl[i].value);
        }
        nextFilters = { ...nextFilters, [filterField]: value };
      } else {
        nextFilters = { ...nextFilters, [filterField]: filterValue };
      }
    }

    this.setState({ filters: nextFilters });
  };

  private onApplyFilterClick = (): void => {
    const { sortDirection, sortFieldName } = this.state;
    const parts: string[] = [];

    if (isSortExist(sortDirection, sortFieldName)) parts.push(getSearchOrder(sortDirection, sortFieldName));

    const filtersForUrl = this.normalizeFiltersForQuery(this.state.filters);
    if (isFilterExist2(filtersForUrl)) parts.push(getSearchFilter(filtersForUrl));

    this.props.history.push({ pathname: this.state.basePath, search: parts.join('&') });
  };

  private onClearFilterClick = (): void => {
    this.props.history.push({ pathname: this.state.basePath, search: '' });
  };

  private renderMapModal = () => {
    const { isMapModalOpen, selectedItem } = this.state;
    const point = propz.get(selectedItem, ['childEvent', 'venue', 'point']);

    return (
      <SimpleModal isOpen={isMapModalOpen} onCloseClick={this.closeMapModal} title="View map" customClass="modal-xl">
        <Map point={point} customStylingClass="eChildEventVenueMap" isMarkerDraggable={false} />
      </SimpleModal>
    );
  };

  private openMapModal = message => {
    this.setState({ isMapModalOpen: true, selectedItem: message });
  };
  private closeMapModal = () => {
    this.setState({ isMapModalOpen: false, selectedItem: undefined });
  };

  private renderDetailsModal = () => {
    const { isDetailsModalOpen, selectedItem } = this.state;
    return (
      <SimpleModal
        isOpen={isDetailsModalOpen}
        onCloseClick={this.closeDetailsModal}
        showFooter={false}
        title="Consent request details"
        side="right"
        customClass="parentConsentDrawer"
        dialogStyle={{ maxWidth: 560 }}
      >
        <ConsentRequestDetails message={selectedItem} childIdList={this.state.children.map(c => c.id)} />
      </SimpleModal>
    );
  };

  private openDetailsModal = message => {
    this.setState({ isDetailsModalOpen: true, selectedItem: message });
  };
  private closeDetailsModal = () => {
    this.setState({ isDetailsModalOpen: false, selectedItem: undefined });
  };

  private onReturnToInboxClick = (consentRequest: EventInvitationMessage) => {
    const { user } = this.props;
    this.setState({ isLoading: true });
    cancelRejectionOfParentConsentRequest(user, consentRequest.id)
      .then(() => this.setItems())
      .then(() => {
        if (this.props.setNeedUpdate) this.props.setNeedUpdate();
      })
      .catch(() => {
        this.setState({ isLoading: false });
      });
  };

  private onChildPickerClick = (childId: string): void => {
    const { children, sortDirection, sortFieldName } = this.state;

    const nextFilters = {
      ...this.state.filters,
      childIdList: childId === 'all' ? children.map(c => c.id) : [childId]
    };

    this.setState({ filters: nextFilters }, () => {
      const parts: string[] = [];
      const year = parse(this.props.location.search).year;
      if (this.props.mode === 'archive' && typeof year === 'string') parts.push(`year=${year}`);
      if (isSortExist(sortDirection, sortFieldName)) parts.push(getSearchOrder(sortDirection, sortFieldName));

      const filtersForUrl = this.normalizeFiltersForQuery(this.state.filters);
      if (isFilterExist2(filtersForUrl)) parts.push(getSearchFilter(filtersForUrl));

      this.props.history.push({ pathname: this.state.basePath, search: parts.join('&') });
    });
  };

  private openAcceptModal = message => {
    this.setState({ isEditModalOpen: true, selectedItem: message, modalMode: 'accept' });
  };

  private onAcceptFromArchiveClick = async (fields: MessageField[], submission?: FormSubmission) => {
    const { user } = this.props;
    const { selectedItem } = this.state;
    const id = propz.get(selectedItem, ['consentRequest', 'id'], '');

    this.setState({ isLoading: true });

    try {
      await acceptParentConsentRequest(user, id, { fields, ...(submission || {}) });

      await this.setItems();

      this.setState({ isEditModalOpen: false, selectedItem: undefined, modalMode: undefined, isLoading: false });
    } catch {
      this.setState({ isLoading: false });
    }
  };

  private openEditModal = message => {
    this.setState({ isEditModalOpen: true, selectedItem: message, modalMode: 'edit' });
  };

  private closeEditModal = () => {
    this.setState({ isEditModalOpen: false, selectedItem: undefined });
  };

  private onUpdateConsentRequestClick = (fields: MessageField[], submission?: FormSubmission) => {
    const { user } = this.props;
    const { selectedItem } = this.state;
    const id = propz.get(selectedItem, ['consentRequest', 'id'], '');
    const data = { fields, ...(submission || {}) };

    this.setState({ isLoading: true });

    updateParentConsentRequest(user, id, data)
      .then(() => this.setItems())
      .then(() => {
        this.setState({ isEditModalOpen: false, selectedItem: undefined });
      })
      .then(() => {
        this.setState({ isLoading: false });
      })
      .catch(() => {
        this.setState({ isLoading: false });
      });
  };

  private renderEditModal = () => {
    const { isEditModalOpen, selectedItem, modalMode } = this.state;
    if (!isEditModalOpen || !selectedItem) return null;

    const { consentRequest } = selectedItem;
    const isAcceptMode = modalMode === 'accept';
    const title = isAcceptMode ? 'Accept consent' : 'Edit response';
    const onAccept = isAcceptMode ? this.onAcceptFromArchiveClick : this.onUpdateConsentRequestClick;

    const wasRejected = String(consentRequest.invitationStatus || '').toUpperCase() === 'REJECTED';

    const messageForForm: EventInvitationMessage =
      isAcceptMode && wasRejected
        ? {
            ...consentRequest,
            fields: (consentRequest.fields || []).map(f => ({ ...f, value: '' })),
            formAnswers: []
          }
        : consentRequest;

    return (
      <SimpleModal
        isOpen={isEditModalOpen}
        onCloseClick={this.closeEditModal}
        showFooter={false}
        customClass="AcceptModal"
        title={title}
        guardUnsavedChanges
        unsavedChangesMessage="You have unsaved consent answers. If you close now, those changes will be lost."
      >
        <ParentalConsentRequestForm
          user={this.props.user}
          message={messageForForm}
          onCloseClick={this.closeEditModal}
          onAcceptClick={onAccept}
          submitLabel={isAcceptMode ? 'Give consent' : 'Save changes'}
        />
      </SimpleModal>
    );
  };

  private onCancelConsentClick = (item: { consentRequest: EventInvitationMessage; childEvent: SchoolEvent }) => {
    const { user } = this.props;

    const messageId = propz.get(item, ['consentRequest', 'id'], '');
    const threadId = propz.get(item, ['consentRequest', 'threadId'], '');

    this.setState({ isLoading: true });

    const tryReject = (id: string) => rejectParentConsentRequest(user, id);

    tryReject(messageId)
      .catch((err: any) => {
        const msg = (err && (err.details?.text || err.message)) || '';
        const isNotFound = /There is no EventInvitationMessage/i.test(msg);
        if (isNotFound && threadId && threadId !== messageId) {
          return tryReject(threadId);
        }
        throw err;
      })
      .then(() => this.setItems())
      .then(() => {
        this.setState({ selectedItem: undefined, isLoading: false, isEditModalOpen: false });
      })
      .catch(() => this.setState({ isLoading: false }));
  };

  render() {
    const { isLoading, isFiltersOpen, total, currentPage, items, filters, children } = this.state;
    const isPreviousYears = this.props.mode === 'archive';
    const archiveSearch = parse(this.props.location.search);
    const hasAppliedArchiveFilters = Object.keys(archiveSearch).some(key => key !== 'page' && key !== 'order');

    const childIdList = children.map(child => child.id);

    if (isLoading) return <Loader />;

    const selectedChildIds =
      filters.childIdList && filters.childIdList.length ? filters.childIdList : children.map(c => c.id);

    return (
      <main className="parentPage parentListPage parentConsentPage">
        {this.renderMapModal()}
        {this.renderDetailsModal()}
        {this.renderEditModal()}

        <ParentPageHeader
          title="Consent requests"
          subtitle={isPreviousYears ? 'Choose a school year to review older consent requests.' : 'Events that have already happened this school year. Read only.'}
          tabs={[
            { label: 'Upcoming', onClick: () => this.props.history.push('/consentRequests/inbox') },
            {
              label: 'Past this year',
              active: !isPreviousYears,
              count: !isPreviousYears ? total : undefined,
              onClick: () => this.props.history.push('/consentRequests/history')
            },
            {
              label: 'Previous years',
              active: isPreviousYears,
              count: isPreviousYears ? total : undefined,
              onClick: () => this.props.history.push('/consentRequests/archive')
            }
          ]}
        />

        <ItemsBar
          items={children}
          itemIdList={selectedChildIds}
          onClick={this.onChildPickerClick}
          allItemsTitle="All children"
          getItemName={(c: any) => `${c.firstName} ${c.lastName}`}
        />

        {isPreviousYears ? (
          <label className="parentConsentYear">
            <span>School year</span>
            <select
              value={typeof archiveSearch.year === 'string' ? archiveSearch.year : ''}
              onChange={event =>
                this.props.history.push({
                  pathname: '/consentRequests/archive',
                  search: event.target.value ? `year=${event.target.value}` : ''
                })
              }
            >
              <option value="">Choose a year</option>
              {[1, 2, 3, 4, 5].map(offset => {
                const year = Number(academicYearRange().from.slice(0, 4)) - offset;
                return <option key={year} value={year}>{year}–{String(year + 1).slice(-2)}</option>;
              })}
            </select>
          </label>
        ) : null}

        {total > CARD_LIMIT ? <div className="parentListControls">
          <button
            className={isFiltersOpen ? 'parentFilterButton is-active' : 'parentFilterButton'}
            onClick={() => this.setState(prev => ({ isFiltersOpen: !prev.isFiltersOpen }))}
          >
            <span className="parentFilterButton__icon" aria-hidden="true" /> Filters
          </button>

          <Pagination2
            currentPage={currentPage}
            total={total}
            setCurrentPageParams={this.setCurrentPageParams}
            limit={CARD_LIMIT}
            modern
          />
        </div> : null}
        {!isPreviousYears ? <AppliedTextFilterChip
          history={this.props.history}
          location={this.props.location}
          filters={[
            { filterKey: 'sport', label: 'Activity/Sport' },
            { filterKey: 'startTime', label: 'Event date', type: 'date' },
            {
              filterKey: 'invitationStatus',
              label: 'Status',
              valueLabels: { ACCEPTED: 'Accepted', REJECTED: 'Declined' }
            }
          ]}
        /> : null}

        {isFiltersOpen && (
          <div className="parentFilterSurface">
            <ParentFilterBar
              filters={this.state.filters}
              onTableFilterChange={this.onTableFilterChange}
              onApply={this.onApplyFilterClick}
              onClear={this.onClearFilterClick}
              onCancel={() => this.setState({ isFiltersOpen: false })}
              hint={<>To search the archive by activity or sport, also select an event date interval.</>}
              labels={{ text: 'Activity/Sport', date: 'Event date', status: 'Invitation status' }}
              fieldKeys={{ textKey: 'sport', dateKey: 'startTime', statusKey: 'invitationStatus' }}
              showStatus
              statusOptions={[
                { value: '', label: 'All' },
                { value: 'ACCEPTED', label: 'Accepted' },
                { value: 'REJECTED', label: 'Declined' },
                { value: 'OUTDATED', label: 'Outdated' }
              ]}
            />
          </div>
        )}
        {items.length === 0 ? (
          <div className="parentListEmpty">
            <strong>
              {isPreviousYears && !hasAppliedArchiveFilters
                ? 'Choose a school year'
                : isPreviousYears
                ? 'No consent requests match your filters'
                : 'Nothing earlier this academic year'}
            </strong>
            {isPreviousYears ? (
              <span>
                {hasAppliedArchiveFilters
                  ? 'Try changing the event date range or removing one of the other filters.'
                  : 'Pick a year above to see its consent requests.'}
              </span>
            ) : null}
          </div>
        ) : (
          <ParentConsentEventList
            items={items}
            childIdList={childIdList}
            readOnly
            onView={this.openDetailsModal}
          />
        )}
      </main>
    );
  }
}
